import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardWithIcon, ContentSection, CustomList, CustomListItem, Heading } from "@cinch-labs/design-system";
import { useViewport } from "@cinch-labs/shared-util";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import styles from "./why-cinch.module.css";
const WhyCinch = ({ image , title , cards  })=>{
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 1024;
    return /*#__PURE__*/ _jsx("section", {
        className: styles["whyCinchContainer"],
        "data-testid": "whycinch",
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles["whyCinchInner"],
            children: [
                /*#__PURE__*/ _jsxs(Heading, {
                    fontSize: "h1",
                    className: styles["whyCinchHeading"],
                    children: [
                        title,
                        " "
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles["contentWrapper"],
                    children: [
                        /*#__PURE__*/ _jsx(CustomList, {
                            customClassNames: {
                                bulletContainer: styles["bulletContainer"],
                                listItem: styles["listItem"]
                            },
                            children: cards.map((card)=>/*#__PURE__*/ _jsx(CustomListItem, {
                                    bullet: /*#__PURE__*/ _jsx(CardWithIcon, {
                                        className: styles["cardWithIcon"],
                                        iconName: card.icon,
                                        iconColor: "vividViolet",
                                        iconSize: 37
                                    }),
                                    children: /*#__PURE__*/ _jsx(ContentSection, {
                                        title: card.title,
                                        classNames: {
                                            title: styles["contentSectionTitle"],
                                            body: styles["contentSectionBody"]
                                        },
                                        sectionWrapperClass: styles["contentSectionWrapper"],
                                        children: renderWithResolver(card.body)
                                    })
                                }, card.name))
                        }),
                        !isMobile ? /*#__PURE__*/ _jsx("div", {
                            className: styles["whyCinchImageContainer"],
                            "data-testid": "featured-cards-image-section",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: getStoryblokImageServiceUrl(image.filename, {
                                    width: 360,
                                    height: 414,
                                    filters: [
                                        {
                                            quality: 80
                                        }
                                    ]
                                }),
                                alt: image.alt ?? ""
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};
export default WhyCinch;
